// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mtftF","select":"styles_select__1zQYm"};